import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLanguage } from '../context/LanguageContext';

const BannerHeader: React.FC = () => {
  const { t } = useLanguage();
  
  // Ad badge with tooltip
  const adBadge = (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="ad-tooltip">Third-party ad. Interact at your own risk</Tooltip>}
    >
      <div 
        className="position-absolute" 
        style={{ 
          top: "0", 
          right: "0", 
          zIndex: 10, 
          padding: "2px 5px",
          backgroundColor: "rgba(108, 117, 125, 0.8)",
          borderRadius: "0 4px 0 4px",
          cursor: "help",
          fontSize: "10px",
          color: "white",
          fontWeight: "bold"
        }}
      >
        Ad
      </div>
    </OverlayTrigger>
  );
  
  return (
    <div className="d-flex justify-content-end">
        <a href='https://www.okx.com/join/PISCAN' target="_blank" rel="noopener noreferrer" className="text-decoration-none">
      <div
        className="position-relative border rounded "
        style={{
          width: "320px",
          height: "100px",
          overflow: "hidden",
          backgroundColor: "rgba(248, 249, 250, 0.5)",
        }}
      >
        {adBadge}
        <img 
          src="/assets/okx_banner.png" 
          alt="OKX Banner"
          width="320"
          height="100"
          style={{
            display: "block",
            objectFit: "cover"
          }}
        />
      </div>
      
        </a>
    </div>
  );
};

export default BannerHeader;